module.exports = __webpack_public_path__ + "static/media/success.50fec0d7.gif";